import { useEffect } from 'react';

/**
 * Renders a JSON-LD <script> tag via direct DOM injection (textContent, no innerHTML).
 *
 * Why not use <script dangerouslySetInnerHTML>?
 *   • Many static analyzers flag dangerouslySetInnerHTML as an XSS risk even when
 *     the content is JSON, not HTML.
 *   • textContent NEVER parses its input as HTML — it's strictly impossible to
 *     break out of the script tag this way, even with malformed data.
 *
 * Use this component anywhere you previously had
 *     <script type="application/ld+json" dangerouslySetInnerHTML={...} />
 */
const JsonLd = ({ data }) => {
  useEffect(() => {
    if (!data) return;
    const id = `jsonld-${typeof data['@type'] === 'string' ? data['@type'] : 'data'}`;
    // Remove any previous instance so we don't pile up duplicates on re-render
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [data]);

  return null;
};

export default JsonLd;
